import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { RestEndpoint } from 'src/modules/sm-base/models/rest-endpoint.model';
import { TableData } from 'src/modules/sm-base/models/table-data.model';
import { TableRow } from 'src/modules/sm-base/models/table-row.model';
import { TableSortColumn } from 'src/modules/sm-base/models/table-sort-column.model';
import { TableCellType } from 'src/modules/sm-base/netgen/TableCellType';
import { TableColumn } from 'src/modules/sm-base/netgen/TableColumn';
import { ObjectOfSimpleDataTypes } from 'src/modules/utils/shared/object-of-simple-data-types.model';
import { Objects } from "src/modules/utils/shared/objects";
import { EnaioCertificateService } from '../../services/enaio-certificate.service';
import { ClassHoliday } from '../../shared/class-holiday.entity';
import { ClassRegister } from '../../shared/class-register.entity';

@Component({
    selector: 'app-class-holidays',
    templateUrl: './class-holidays.component.html',
    styleUrls: ['./class-holidays.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ClassHolidaysComponent extends ComponentView {

    service = inject(EnaioCertificateService);

    neededParams: ObjectOfSimpleDataTypes = { id: "number" };
    id: number;

    classRegister: ClassRegister;
    orgData: ClassHoliday[];
    table: TableData;

    async initParams(): Promise<boolean> {
        this.classRegister = await this.service.restGetClassRegister(this.id, ["holidays"], null, true);

        this.orgData = Objects.cloneDeep(this.classRegister.holidays);

        this.table = new TableData([
            new TableColumn("from", "Von", TableCellType.date, 1, {
                editable: true
            }),
            new TableColumn("to", "Bis", TableCellType.date, 1, {
                editable: true
            }),
            new TableColumn("title", "Bezeichnung", TableCellType.string, 30, {
                editable: true
            })
        ], this.classRegister.holidays.map(h => new TableRow("", h)), ["from"], {
            generator: async () => Promise.resolve(new TableRow("", Objects.fromPlain(ClassHoliday, {
                from: new Date(),
                to: new Date(),
                title: ""
            })))
        });

        await this.service.updateNavigationClassRegister(this.id, [
            { label: "Klassenfahrten", routerLink: ["/enaio-certificates", "class-registers", "holidays", this.id] }
        ]);
        return true;
    }

    override getCanDeactivateMessage(): string {
        return this.isChanged() ? "" : null;
    }

    add(): void {
		this.table.rows = [...this.table.rows, new TableRow("", Objects.fromPlain(ClassHoliday, {
            from: new Date(),
            to: new Date(),
            title: ""
        }))];
	}

    isChanged(): boolean {
        return !Objects.equalsDeep(this.fromGui(), this.orgData);
    }

    fromGui(): ClassHoliday[] {
        return this.table.rows.map(h => h.raw as ClassHoliday);
    }

    async save(): Promise<void> {
        await this.app.saveDataHandler(async () => RestEndpoint.main().query({ id: this.id }).body(this.fromGui()).post().run("api/cer/classregister/holidays").getText(), this, true, true);
    }
}
